import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'emotion-theming';
import i18next from 'i18next';
import { setLanguage } from '../data/app/AppActions.js';
import { loadResourceTranslations } from '../data/translated_resource/TranslatedResourceActions.js';
import { HeaderContainer } from '../components/Themed.js';
import './Header.css';

const defaultLanguages = [
  { id: 'en-US', label: 'English (US)', flag: 'US' },
  { id: 'en-CA', label: 'English (CA)', flag: 'CA' },
  { id: 'en-GB', label: 'English (UK)', flag: 'GB' },
  { id: 'es-MX', label: 'Español (MX)', flag: 'MX' },
  { id: 'fr-CA', label: 'Français (CA)', flag: 'CA' },
  { id: 'ja-JP', label: '日本語 (JP)', flag: 'JP' },
  { id: 'de-DE', label: 'Deutsch (DE)', flag: 'DE' },
  { id: 'vi-VN', label: 'Tiếng Việt (VN)', flag: 'VN' },
  { id: 'ko-KR', label: '한국인 (KR)', flag: 'KR' },
  { id: 'zh-TW', label: '中國人 (CN)', flag: 'CN' },
];

// Values should be one of defaultLanguages's id's
const backendKeyToUILang = {
  'en': 'en-US',
  'en-US': 'en-US',
  'en-UK': 'en-GB',
  'en-GB': 'en-GB',
  'en-CA': 'en-CA',
  'fr': 'fr-FR',
  'fr-FR': 'fr-FR',
  'fr-CA': 'fr-CA',
}

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      languageListVisible: false,
    };

    this.backClick = this.backClick.bind(this);
    this.renderLanguageDropdown = this.renderLanguageDropdown.bind(this);
    this.renderLanguage = this.renderLanguage.bind(this);
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
  }

  componentDidMount() {
    window.onclick = () => {
      const { languageListVisible } = this.state;
      if (languageListVisible) {
        this.setState({ languageListVisible: false });
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    // Company loaded
    if (nextProps.companyId && !nextProps.appLanguage) {
      const languages = this.getLanguages()

      const defaultLanguage = languages.find((e) => e.id === backendKeyToUILang[this.props.companyLocale]) ||
                              languages.find((e) => e.id === 'en') ||
                              languages[0]

      this.handleChangeLanguage(defaultLanguage);
    }
  }

  backClick() {
    if (this.props.location.pathname === '/clientPersonSelection') {
      this.props.history.push('/clientInformation');
    } else if (this.props.location.pathname === '/services/0') {
      this.props.history.push('/');
    } else if (this.props.location.pathname === '/clientCheckin') {
      this.props.history.push('/');
    } else if (this.props.location.pathname === '/clientInformation') {
      this.props.history.push('/');
    } else if (this.props.isBackVisible) {
      this.props.history.goBack();
    }
  }

  handleChangeLanguage(language) {
    const {
      setLanguage,
      companyId,
      companyLanguages,
      loadResourceTranslations,
    } = this.props

    const afterChange = () => {
      setLanguage(language.id);
      this.setState({
        languageListVisible: false,
      });
      i18next.changeLanguage(language.ui_lang);
    }

    if (companyLanguages.length > 1) {
      loadResourceTranslations(companyId, language.id).then(() => {
        afterChange()
      })
    } else {
      afterChange()
    }
  }

  renderLanguage(language) {
    return (
      <>
        <div className={`fflag ff-lg fflag-${language.flag}`}/>
        <div className="selected-language">{language.label}</div>
      </>
    );
  }

  getLanguages() {
    let result = []

    if (this.props.companyLanguages && this.props.companyLanguages.length > 1) {
      this.props.companyLanguages.forEach((lang) => {
        result.push({
          id: lang.language_code,
          label: lang.name,
          ui_lang: backendKeyToUILang[lang.language_code] || backendKeyToUILang[this.props.companyLocale] || 'en-US',
          flag: lang.country_code,
        })
      })
    } else {
      defaultLanguages.forEach((lang) => {
        result.push({
          id: lang.id,
          label: lang.label,
          ui_lang: lang.id,
          flag: lang.flag,
        })
      })
    }

    return result
  }

  renderLanguageDropdown() {
    const { languageListVisible } = this.state;
    const { appLanguage } = this.props
    const languages = this.getLanguages()
    const language = languages.filter(l => l.id === appLanguage)[0] || languages[0];

    return (
      <>
        <button
          className="language-picker"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ languageListVisible: !languageListVisible });
          }}
        >
          {this.renderLanguage(language)}
          <div className="selected-language-caret">&#9660;</div>
        </button>
        {languageListVisible && (
          <div className="language-list">
            {this.getLanguages().map((l, i) => (
              <div
                className="language-elem"
                key={l.id}
                onClick={() => this.handleChangeLanguage(l)}
              >
                {this.renderLanguage(l)}
              </div>
            ))}
          </div>
        )}
      </>
    );
  }

  render() {
    return (
      <HeaderContainer>
        <div
          style={{
            opacity: this.props.isBackVisible ? 1 : 0,
            transition: '.5s',
          }}
        >
          <button
            className="back-button"
            style={{ borderColor: this.props.theme.backButtonColor }}
            onClick={this.backClick}
          >
            <i
              className="fas fa-chevron-left"
              style={{
                color: this.props.theme.backButtonColor,
                fontSize: '26px',
              }}
            />
          </button>
        </div>
        {this.props.logoUrl && (
          <img alt="logo" style={{ height: '100%' }} src={this.props.logoUrl} />
        )}
        {this.renderLanguageDropdown()}
      </HeaderContainer>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    logoUrl: state.app.businessInfo.company.kiosk_config.logo,
    companyLanguages: state.app.businessInfo.company.company_languages || [],
    companyLocale: state.app.businessInfo.company.locale_uuid,
    companyId: state.app.businessInfo.company.id,
    appLanguage: state.app.language,
  };
}

export default withTheme(
  withRouter(
    connect(
      mapStateToProps,
      {
        setLanguage,
        loadResourceTranslations,
      }
    )(Header)
  )
);
